import { render, staticRenderFns } from "./face-item.vue?vue&type=template&id=7fcd6974&scoped=true"
import script from "./face-item.vue?vue&type=script&lang=js"
export * from "./face-item.vue?vue&type=script&lang=js"
import style0 from "./face-item.vue?vue&type=style&index=0&id=7fcd6974&lang=less&scoped=true"
import style1 from "./face-item.vue?vue&type=style&index=1&id=7fcd6974&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd6974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fcd6974')) {
      api.createRecord('7fcd6974', component.options)
    } else {
      api.reload('7fcd6974', component.options)
    }
    module.hot.accept("./face-item.vue?vue&type=template&id=7fcd6974&scoped=true", function () {
      api.rerender('7fcd6974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/face-item.vue"
export default component.exports